<template>
  <el-dialog
    :visible="visible"
    title="结算信息变更"
    width="1100px"
    @close="$emit('update:visible', false)"
    @open="fetch"
  >
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="itemTitle" label="商品"></el-table-column>
      <el-table-column prop="measureType" label="计量方式"></el-table-column>
      <el-table-column label="结算单价">
        <template v-slot="scope">
          <div :class="{ 'c-hover': scope.row.settlePerAmount !== scope.row.settlePerAmountPre }">
            {{ scope.row.settlePerAmount | currencyFormat }}/{{ scope.row.chargeUnit }}
          </div>
          <div
            class="f-12 c-9 line-through"
            v-if="scope.row.settlePerAmount !== scope.row.settlePerAmountPre"
          >
            {{ scope.row.settlePerAmountPre | currencyFormat }}/{{ scope.row.chargeUnit }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="结算重量">
        <template v-slot="scope">
          <div :class="{ 'c-hover': scope.row.settleWeight !== scope.row.settleWeightPre }">
            {{ scope.row.settleWeight | formatWeight }}吨
          </div>
          <div
            class="f-12 c-9 line-through"
            v-if="scope.row.settleWeight !== scope.row.settleWeightPre"
          >
            {{ scope.row.settleWeightPre | formatWeight }}吨
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="结算数量">
        <template v-slot="scope">
          <div :class="{ 'c-hover': scope.row.settleQuantity !== scope.row.settleQuantityPre }">
            {{ scope.row.settleQuantity }}件
          </div>
          <div
            class="f-12 c-9 line-through"
            v-if="scope.row.settleQuantity !== scope.row.settleQuantityPre"
          >
            {{ scope.row.settleQuantityPre }}件
          </div>
        </template>
      </el-table-column>
      <el-table-column label="结算金额">
        <template v-slot="scope">
          <div :class="{ 'c-hover': scope.row.settleAmount !== scope.row.settleAmountPre }">
            {{ scope.row.settleAmount | currencyFormat }}
          </div>
          <span
            class="f-12 c-9 line-through"
            v-if="scope.row.settleAmountPre !== scope.row.settleAmount"
            >{{ scope.row.settleAmountPre | currencyFormat }}</span
          >
        </template>
      </el-table-column>
      <el-table-column prop="operateUserName" label="修改人"></el-table-column>
      <el-table-column label="修改时间">
        <template v-slot="scope">
          <span>{{ scope.row.gmtCreated | parseTime }}</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      v-show="total > 0"
      style="text-align:right;margin-top:20px;"
      @size-change="handleSizeChange"
      @current-change="paging"
      :current-page="criteria.pageNo"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="criteria.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
  </el-dialog>
</template>

<script>
import NP from 'number-precision'

const defaultCriteria = {
  pageNo: 1,
  pageSize: 10
}

export default {
  props: {
    visible: Boolean,
    data: Object
  },
  data() {
    return {
      criteria: { ...defaultCriteria },
      tableData: [],
      total: 0
    }
  },
  methods: {
    handleSizeChange(val) {
      this.criteria.pageSize = val
      this.fetch()
    },
    paging(page) {
      this.criteria.pageNo = page
      this.fetch()
    },
    async fetch() {
      const { id } = this.data

      const request = { sourceType: 2, sourceId: id, ...this.criteria }

      const { success, data } = await this.$post('settle.seller.querySettleItemChangeLogs', {
        request
      })
      if (success && data) {
        const { totalNum, settleItemChangeLogVOList } = data[0]
        this.total = totalNum
        this.tableData = settleItemChangeLogVOList
      }
    }
  }
}
</script>

<style lang="less" scoped>
.line-through {
  text-decoration: line-through;
}
</style>
